export const initialDetailFilters = {
    from: undefined,
    to: undefined,
    locations: [],
    regions: []
};
export const detailsFilterTemplate = {
    from: new Date(),
    to: new Date(),
    locations: [],
    regions: []
};
export const initialDetailsFilterProps = {
    ...initialDetailFilters,
    updateLocation: ()=>{},
    updateRegion: ()=>{},
    updateDateRange: ()=>{}
};
